import React, { useContext } from "react";
export const PrizeLocatorContext = React.createContext(null);
export const usePrizeLocatorContext = () => {
    const context = useContext(PrizeLocatorContext);
    if (!context) {
        throw new Error("usePrizeLocatorContext hook is used outside of PrizeLocatorContext");
    }
    return context;
};
//# sourceMappingURL=usePrizeLocatorContext.js.map